import React       from 'react';

import { Box }     from '../../atoms/Layout/Box/Box';
import { Game }    from '../../models/Game';
import classNames from 'classnames';
import styles from './AtariBlock.css';
import { Categories } from '../../constants/Pages';


type AtariBlockProps = {
    className?: string;
    game?: Game;
};

export class AtariBlock extends React.Component<AtariBlockProps> {
    render() {
        const { className, game } = this.props;
        if (game && game.categories.indexOf(Categories.Atari) === -1)
            return null;

        return (
            <Container className = {className}>
                <QuestionBorder />
                <Box align = "center" justify = "center" paddingT = "xs" paddingB = "xs" wrap = "wrap">
                    <AtariLink href='/help#atari'> 
                        ©2021 Atari Interactive, Inc.
                    </AtariLink>
                </Box>
            </Container>
        );
    } 
}
const Container = ({ className, ...props }: any) => <div className = {classNames(styles.container, className)} {...props} />;
const QuestionBorder = (props: any) => <div className = {styles.questionBorder} {...props} />;
const AtariLink = (props: any) => <a className = {styles.AtariLink} {...props} />;
